import { Exercise } from "../../../models/Exercise";
import { useEffect, useState } from "react";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";
import { GET_AVAILABLE_EXERCISE_UNIVERSAL } from "../../../api/apiRoutes";
import { addDays, format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import qs from "qs";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../store";
import { TOUR_SALE } from "../../../routes";
import { setExerciseName, setExerciseZoneId } from "../../../store/pseudoModal/pseudoModalsActions";

export default function useTours() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const facilityIds = useFacility();
  const { get } = useApiRequest();

  const exerciseName = useSelector((state: State) => state.pseudoModals.exerciseName);
  const exerciseDescription = useSelector((state: State) => state.pseudoModals.exerciseDescription);
  const exerciseIdsUrlParam = qs.parse(location.search.slice(1)).exerciseIds as string;
  const exerciseNameUrlParam = qs.parse(location.search.slice(1)).exerciseName as string;

  const [loading, setLoading] = useState(true);
  const [exercises, setExercises] = useState<Exercise[]>([]);

  // KROK 1. POBIERANIE DOSTEPNYCH DNI, NA WYNIKACH WYKONAC REQUEST DRUGI
  const getToursEvents = async () => {
    setLoading(true);
    const formattedDateFrom = format(new Date(), "yyyy-MM-dd");
    const formattedDateTo = format(new Date(addDays(new Date(), 360)), "yyyy-MM-dd");
    const { result, isError } = await get(
      GET_AVAILABLE_EXERCISE_UNIVERSAL(
        facilityIds,
        formattedDateFrom,
        formattedDateTo,
        exerciseName.replace(/%/g, "%25")
      )
    );
    if (!isError) {
      setExercises(result);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (exerciseNameUrlParam && exerciseIdsUrlParam) {
      dispatch(setExerciseName(exerciseNameUrlParam));
      dispatch(setExerciseZoneId(Number(exerciseIdsUrlParam)));
      setLoading(false);
    }
    //eslint-disable-next-line
  }, [exerciseIdsUrlParam, exerciseNameUrlParam]);

  useEffect(() => {
    if (exerciseName && facilityIds) {
      getToursEvents();
    }
    //eslint-disable-next-line
  }, [exerciseName, facilityIds]);

  const navigateToTourSale = () => {
    navigate(TOUR_SALE);
  };

  // KROK 2. Pobranie ticketów

  return {
    exercises,
    getToursEvents,
    navigateToTourSale,
    loading,
    exerciseName,
    exerciseDescription,
  };
}
